import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { registerServiceWorker } from './utils/serviceWorkerRegistration';

// 개발 환경에서 알림 테스트 유틸리티 로드
if (process.env.NODE_ENV === 'development') {
  import('./utils/testNotification');
}

// React Query 클라이언트 설정 (성능 최적화)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // 초기 로딩 후에는 비활성화 (성능 개선)
      refetchOnMount: false, // 마운트 시 자동 재조회 비활성화 (불필요한 네트워크 요청 방지)
      refetchOnReconnect: true, // 재연결 시에는 자동 새로고침 유지
      staleTime: 1000 * 60 * 5, // 5분간 신선한 데이터로 간주
      gcTime: 1000 * 60 * 30, // 30분간 캐시 보관 (v5에서 cacheTime -> gcTime으로 변경)
      retry: 1, // 실패 시 1번만 재시도
      retryDelay: 1000, // 재시도 지연 시간 1초
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// --- 🔽 [추가] 프리로더 Handoff 로직 🔽 ---
// 정적 프리로더를 React 앱이 로드된 후 부드럽게 제거

// 1. 정적 프리로더 DOM 요소를 찾습니다.
const preLoader = document.getElementById('pre-loader');

if (preLoader) {
  const safelyRemovePreloader = () => {
    preLoader.classList.add('fade-out');

    preLoader.addEventListener(
      'transitionend',
      () => {
        try {
          preLoader.remove();
        } catch (e) {
          // 이미 제거되었거나 오류 발생 시 무시
        }
      },
      { once: true }
    );

    // transition 이벤트를 받지 못하는 경우를 대비한 안전장치
    // 페이드 아웃 시간(0.2s) + 여유 시간(0.1s) = 300ms
    setTimeout(() => {
      if (preLoader && preLoader.parentNode) {
        preLoader.parentNode.removeChild(preLoader);
      }
    }, 300);
  };

  // React 로딩이 시작되면 즉시 스플래시로 전환되도록 지연 없이 제거
  // 모바일에서 시계 아이콘 확대 효과를 최소화하기 위해 즉시 제거
  safelyRemovePreloader();
}
// --- 🔼 [추가] 여기까지 🔼 ---

// Service Worker 등록 (PWA 기능 활성화)
registerServiceWorker();

